/**
 * A QultureUp difficulty, as a pill — the web's one difficulty palette. (MOB-27)
 *
 * A mission's level and a knowledge question's tier share it: a tier is placed
 * on the mission scale (`QULTUREUP_TIER_ON_MISSION_SCALE`, @tonnie/heroes)
 * before it is coloured, so neither wears a status colour. The Brain assessment
 * widget printed the raw tier ("medium") in green / yellow / red.
 */
import type { QultureUpMissionDifficulty } from '@tonnie/heroes';
import { cn } from '@tonnie/ui';

export const QULTUREUP_LEVEL_TONE = {
  beginner: { color: 'text-success-accessible', bg: 'bg-tone-green-subtle' },
  intermediate: {
    color: 'text-tone-violet',
    bg: 'bg-tone-violet-subtle',
  },
  advanced: {
    color: 'text-tone-amber',
    bg: 'bg-tone-amber-subtle',
  },
} as const satisfies Record<QultureUpMissionDifficulty, { color: string; bg: string }>;

export function QultureUpDifficultyPill({
  level,
  label,
  testId,
}: {
  level: QultureUpMissionDifficulty;
  /** Already translated. */
  label: string;
  testId?: string;
}) {
  const tone = QULTUREUP_LEVEL_TONE[level];
  return (
    <span
      data-testid={testId}
      data-level={level}
      className={cn('text-xs font-medium px-2 py-0.5 rounded-full', tone.color, tone.bg)}
    >
      {label}
    </span>
  );
}
